"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageAssetPanel = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var react_infinite_scroll_component_1 = __importDefault(require("react-infinite-scroll-component"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var ImageFetchingErrorMessage_1 = require("Common/AssetLibrary/ImageLibrary/Components/ImageFetchingErrorMessage/ImageFetchingErrorMessage");
var ImageAssetPanel = (function (_super) {
    __extends(ImageAssetPanel, _super);
    function ImageAssetPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.isInfiniteScrollLoading = false;
        _this.panelRef = react_1.default.createRef();
        return _this;
    }
    ImageAssetPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, showCollection = _a.showCollection, isLoading = _a.isLoading, hasFetchingError = _a.hasFetchingError, isOutOfNewData = _a.isOutOfNewData, collectionCards = _a.collectionCards, imageCards = _a.imageCards, errorMessageProps = _a.errorMessageProps, wrapperElement = _a.wrapperElement;
        var numberOfCards = showCollection ? collectionCards.length : imageCards.length;
        if (isLoading) {
            return react_1.default.createElement("div", { className: "image-library-asset-panel" }, this.renderLoader("image-library-asset-panel__spinner"));
        }
        if (hasFetchingError) {
            if (!errorMessageProps) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            var header = errorMessageProps.header, content = errorMessageProps.content;
            return (react_1.default.createElement("div", { className: "image-library-asset-panel" },
                react_1.default.createElement("div", { className: "image-library-asset-panel__error-message" },
                    react_1.default.createElement("div", { className: "image-library-asset-panel__error-inner" },
                        react_1.default.createElement(ImageFetchingErrorMessage_1.ImageFetchingErrorMessage, { header: header, content: content })))));
        }
        if (numberOfCards === 0 && isOutOfNewData) {
            return this.renderEmptyState();
        }
        window.setTimeout(function () { return _this.loadSecondPageForLargeScreens(); }, 500);
        return (react_1.default.createElement("div", { className: "image-library-asset-panel", ref: this.panelRef },
            react_1.default.createElement(react_infinite_scroll_component_1.default, { next: this.loadNextPage, hasMore: !isOutOfNewData, loader: this.renderLoader(!this.isInfiniteScrollLoading ? "inactive" : ""), dataLength: numberOfCards, endMessage: this.renderOutOfImagesMessage(), scrollableTarget: wrapperElement.current }, showCollection ? this.renderCollectionGrid() : this.renderImageGrid())));
    };
    ImageAssetPanel.prototype.loadNextPage = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, showCollection, fetchCollections, fetchImages;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, showCollection = _a.showCollection, fetchCollections = _a.fetchCollections, fetchImages = _a.fetchImages;
                        this.isInfiniteScrollLoading = true;
                        if (!showCollection) return [3, 2];
                        return [4, fetchCollections()];
                    case 1:
                        _b.sent();
                        return [3, 4];
                    case 2: return [4, fetchImages()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.isInfiniteScrollLoading = false;
                        return [2];
                }
            });
        });
    };
    ImageAssetPanel.prototype.loadSecondPageForLargeScreens = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var _b, isOutOfNewData, wrapperElement;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this.props, isOutOfNewData = _b.isOutOfNewData, wrapperElement = _b.wrapperElement;
                        if (!this.panelRef.current || isOutOfNewData) {
                            return [2];
                        }
                        if (!(((_a = wrapperElement.current) === null || _a === void 0 ? void 0 : _a.clientHeight) > this.panelRef.current.clientHeight)) return [3, 2];
                        return [4, this.loadNextPage()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    ImageAssetPanel.prototype.renderImageGrid = function () {
        return react_1.default.createElement("div", { className: "image-library-asset-panel__image-grid" }, this.props.imageCards);
    };
    ImageAssetPanel.prototype.renderCollectionGrid = function () {
        return react_1.default.createElement("div", { className: "image-library-asset-panel__collection-grid" }, this.props.collectionCards);
    };
    ImageAssetPanel.prototype.renderEmptyState = function () {
        return (react_1.default.createElement("div", { className: "image-library-asset-panel" },
            react_1.default.createElement("div", { className: "image-library-asset-panel__empty-state" },
                react_1.default.createElement(kaleidoscope_1.EmptyState, { title: "There's nothing here!" }))));
    };
    ImageAssetPanel.prototype.renderLoader = function (spinnerClassName) {
        return (react_1.default.createElement("div", { className: "image-library-asset-panel__spinner-wrapper" },
            react_1.default.createElement(kaleidoscope_2.Spinner, { primary: true, size: kaleidoscope_2.SpinnerSize.Large, className: spinnerClassName })));
    };
    ImageAssetPanel.prototype.renderOutOfImagesMessage = function () {
        return (react_1.default.createElement("div", { className: "image-library-asset-panel__out-of-images" },
            react_1.default.createElement("p", null, "All images loaded!")));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof react_1.default !== "undefined" && react_1.default.RefObject) === "function" ? _a : Object)
    ], ImageAssetPanel.prototype, "panelRef", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ImageAssetPanel.prototype, "isInfiniteScrollLoading", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], ImageAssetPanel.prototype, "loadNextPage", null);
    ImageAssetPanel = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageAssetPanel);
    return ImageAssetPanel;
}(react_1.default.Component));
exports.ImageAssetPanel = ImageAssetPanel;
